import { NgModule, Optional, SkipSelf } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { OktaAuthModule } from '@okta/okta-angular';
import { StoreModule } from '@ngrx/store';
import { reducers, metaReducers } from './store/reducers';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';

import { ConfigInitializer } from './app.config';

import { OktaAuthTokenService } from './services';

import {
  ConfigService,
  ReferralApiService,
  CustomUrlSerializerProvider,
  SourceService,
  SourceLogService,
  AccessService,
  ApplicationConfigService,
} from '@referrals/core/services';
import { AuthInterceptor } from '@referrals/core/interceptors';
import { environment } from '../../environments/environment';

@NgModule({
  imports: [
    StoreModule.forRoot(reducers, { metaReducers }),
    !environment.production ? StoreDevtoolsModule.instrument() : [],
    OktaAuthModule,
  ],
  providers: [
    ConfigService,
    ConfigInitializer,
    CustomUrlSerializerProvider,
    ReferralApiService,
    SourceService,
    AccessService,
    ApplicationConfigService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      deps: [ConfigService, OktaAuthTokenService],
      multi: true,
    },    
    SourceLogService,
  ],
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    if (parentModule) {
      throw new Error(
        'CoreModule has already been loaded. You should only import Core modules in the AppModule only.'
      );
    }
  }
}
